// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.all-pills {
  padding: 14px 0 24px;
}
.all-pills h2 {
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
  color: var(--sebrae-blue-6);
  margin: 24px 0 16px;
}
.all-pills p {
  font-size: 13px;
  line-height: 1.2;
}
.all-pills .content {
  padding: 24px 0;
}
.all-pills .pagination {
  justify-content: center;
}
@media screen and (min-width: 768px) {
  .all-pills h2 {
    font-size: 23px;
  }
  .all-pills p {
    font-size: 14px;
  }
  .all-pills .content {
    margin-top: 15px;
    max-width: 906px;
  }
  .all-pills .off-desktop {
    display: none;
  }
  .all-pills .all-pill-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
  }
  .all-pills .all-pill-cards .card-pill {
    margin: 0;
  }
  .all-pills .pagination {
    justify-content: center;
    margin-top: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/all-pills/index.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;AACF;AACE;EAEI,eAAA;EACA,gBAAA;EAEF,gBAAA;EACA,2BAAA;EACA,mBAAA;AADJ;AAGE;EACE,eAAA;EACA,gBAAA;AADJ;AAGE;EACE,eAAA;AADJ;AAGE;EACE,uBAAA;AADJ;AAIE;EACE;IACE,eAAA;EAFJ;EAIE;IACE,eAAA;EAFJ;EAIE;IACE,gBAAA;IACA,gBAAA;EAFJ;EAIE;IACE,aAAA;EAFJ;EAIE;IACE,aAAA;IACA,qCAAA;IACA,SAAA;EAFJ;EAII;IACE,SAAA;EAFN;EAKE;IACE,uBAAA;IACA,gBAAA;EAHJ;AACF","sourcesContent":[".all-pills {\n  padding: 14px 0 24px;\n\n  h2 {\n    font: {\n      size: 22px;\n      weight: 700;\n    }\n    line-height: 1.2;\n    color: var(--sebrae-blue-6);\n    margin: 24px 0 16px;\n  }\n  p {\n    font-size: 13px;\n    line-height: 1.2;\n  }\n  .content {\n    padding: 24px 0;\n  }\n  .pagination {\n    justify-content: center;\n  }\n\n  @media screen and (min-width: 768px) {\n    h2 {\n      font-size: 23px;\n    }\n    p {\n      font-size: 14px;\n    }\n    .content {\n      margin-top: 15px;\n      max-width: 906px;\n    }\n    .off-desktop {\n      display: none;\n    }\n    .all-pill-cards {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      gap: 24px;\n\n      .card-pill {\n        margin: 0;\n      }\n    }\n    .pagination {\n      justify-content: center;\n      margin-top: 24px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
